// initial state
const state = {
  // 付款类型：
  type: {
    1: '员工报销',
    2: '对公付款',
    3: '预付费用',
    4: '批量付款',
    5: '爱绩效发放',
  },
  // 一级科目
  firstSubjects: {
    1: '库存商品-wip',
    2: '管理费用',
    3: '销售费用',
    4: '主营业务收入',
    5: '财务费用',
    6: '营业外支出',
    7: '应交税费',
    8: '预付账款',
    9: '其他应收账款',
  },
  // 二级科目
  secondSubjects: {
    1: '供应商货款',
    2: '零工服务费',
    3: '快递费',
    4: '交通费',
    5: '住宿费',
    6: '餐费',
    7: '客情费',
    8: '房屋租金',
    9: '物业费',
    10: '水电费',
    11: '办公费',
    12: '固定资产',
    13: '研发费',
    14: '咨询和审计费',
    15: '会议费',
    16: '装潢修理费',
    17: '员工福利费',
    18: '推广费',
    19: '销售退回',
    20: '贷款利息',
    21: '工资',
    22: '绩效工资',
    23: '实习生工资',
    24: '年终奖',
    25: '社保',
    26: '公积金',
    27: '违约金',
    28: '滞纳金',
    29: '进项税额',
    30: '销项税额',
    31: '个人所得税',
    32: '个人借款备用金',
    33: '租赁保证金',
    34: '比稿保证金',
    35: '往来款',
    36: '其他',
  },
  // 付款公司：
  paymentCompanys: {
    1: '小零',
    2: '零启',
    3: '数饮',
    4: '蹦蹦兔',
    5: '小零北京分公司',
    6: '强仝',
    7: '碧于蓝',
  },
  // 付款渠道类型
  paymentChannelTypes: {
    1: '单笔付款',
    2: '零工提现',
  },
  // 付款账户类型
  paymentAccountTypes: {
    1: '银行卡',
    2: '支付宝',
    3: '微信',
  },
  // 发票类型
  invoiceType: {
    1: '普票',
    2: '专票',
    3: '其他'
  },
  taxRateType: {
    1: '1%',
    3: '3%',
    5: '5%',
    6: '6%',
    9: '9%',
    13: '13%',
  },
  status: {
    1: '待一级审批',
    2: '待二级审批',
    3: '待三级审批',
    4: '待四级审批',
    5: '待费用会计审批',
    6: '待财务经理审批',
    7: '待付款',
    8: '已付款',
    9: '付款失败',
    10: '已部分付款',
    11: '待修改',
    12: '已放弃',
    13: '待部门领导审批',
    14: '待特批审批',
    15: '拒付',
    16: '支付中',
    17: '支付异常'
    // 财务审批
    // 会计审批
  },
  searchPaymentStatus: [
    { key: '7', label: '待付款' },
    { key: '15', label: '拒付' },
    { key: '8', label: '已付款' },
    { key: '9', label: '付款失败' },
    { key: '10', label: '已部分付款' },
    { key: '11', label: '待修改' },
    { key: '12', label: '已放弃' },
    { key: '16', label: '支付中' },
    { key: '17', label: '支付异常' },
  ],
  searchApproveStatus: [
    { key: '13', label: '待部门领导审批' },
    { key: '1', label: '待一级审批' },
    { key: '2', label: '待二级审批' },
    { key: '3', label: '待三级审批' },
    { key: '4', label: '待四级审批' },
    { key: '14', label: '待特批人审批' },
    { key: '5', label: '待费用会计审批' },
    { key: '6', label: '待财务经理审批' },
  ],
  writeOffStatus: {
    // 0: '无需冲销',
    1: '未冲销',
    2: '部分冲销',
    3: '已冲销',
  },
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const paymentManagerNew = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/payment-manager-new/payment-manager.store.js